import { EngagementProductWithDeliveryInfoResponseDto } from '@epicuro-next/data/engagement/engagement-models';

export const mapListProductReferenceDates = (
  productsReference: EngagementProductWithDeliveryInfoResponseDto[],
) => {
  const sortedDates = productsReference
    .reduce((deliveryInfoDates: string[], productReference) => {
      return [
        ...deliveryInfoDates,
        ...productReference.deliveryInfo.map(
          (deliveryInfo) => deliveryInfo?.deliveryDate,
        ),
      ];
    }, [])
    .sort(
      (a: string, b: string) => new Date(a).getTime() - new Date(b).getTime(),
    );
  return {
    fromDeliveryDate: sortedDates[0] ?? '',
    toDeliveryDate: sortedDates[sortedDates.length - 1] ?? '',
  };
};
